<template>
  <div>
    <b-overlay :show="busy" rounded="sm">
      <b-card>
        <b-row>
          <b-col>
            <div class="row">
              <div class="col s12">
                <div
                  class="fileuploader center-align text-center"
                  @dragover="dragover"
                  @dragleave="dragleave"
                  @drop="drop"
                >
                  <input
                    type="file"
                    multiple
                    name="fields[assetsFieldHandle][]"
                    id="assetsFieldHandle"
                    class="w-px h-px opacity-0 overflow-hidden absolute"
                    @change="onChange"
                    ref="file"
                    style="display: none"
                    accept=".hot"
                  />
                  <label for="assetsFieldHandle" class="block cursor-pointer">
                    <div
                      v-if="this.filelist.length == 0"
                      id="upload-label"
                      style="width: 200px"
                    >
                      <i class="fa fa-cloud-upload"></i>
                    </div>

                    <span class="tittle"
                      >Click the icon or drop files here</span
                    >
                  </label>

                  <div class="small" v-if="this.filelist.length">
                    <b-row
                      align-v="center"
                      v-for="(file, index) in filelist"
                      :key="index"
                      class="text-sm px-0 py-0"
                    >
                      <b-col cols="auto">
                        <i class="fa fa-file ml-4 pr-1"></i>{{ file.name }}</b-col
                      >
                      <b-col cols="auto">
                        {{
                          file.lastModified | moment("DD/MM/YYYY HH:mm:ss")
                        }}</b-col
                      >
                      <b-col cols="2" class="text-right">
                        {{ file.size | formatSize }}</b-col
                      >
                      <b-col cols="auto" class="px-0">
                        <b-button
                          size="sm"
                          class=""
                          type="button"
                          variant="link"
                          @click="remove(filelist.indexOf(file))"
                          title="Remove file"
                        >
                          <i class="fa fa-times text-danger"></i> </b-button
                      ></b-col>
                    </b-row>
                    <b-row
                      class="text-sm"
                      align-h="end"
                      v-if="this.filelist.length > 0"
                    >
                      <b-col cols="1" class="float-right">
                        <b-button-group size="sm">
                          <b-link @click="$refs.file.value=null;filelist=[]">
                            <i class="fa fa-trash fa-2x text-danger"></i>
                          </b-link>
                        </b-button-group>
                      </b-col>
                    </b-row>
                  </div>
                </div>

                <!-- Preview collection of uploaded documents -->
                <!--    <div class="preview-container">
                  <div class="collection card" id="previews">
                    <div
                      class="
                        collection-item
                        clearhack
                        valign-wrapper
                        item-template
                      "
                      id="zdrop-template"
                    >
                      <div class="left pv zdrop-info" data-dz-thumbnail>
                        <div>
                          <span data-dz-name></span>
                          <span data-dz-size></span>
                        </div>
                        <div class="progress">
                          <div
                            class="determinate"
                            style="width: 0"
                            data-dz-uploadprogress
                          ></div>
                        </div>
                        <div class="dz-error-message">
                          <span data-dz-errormessage></span>
                        </div>
                      </div>

                      <div class="secondary-content actions">
                        <a
                          href="#!"
                          data-dz-remove
                          class="
                            btn-floating
                            ph
                            red
                            white-text
                            waves-effect waves-light
                          "
                          ><i class="material-icons white-text">clear</i></a
                        >
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="1">
            <b-button
              size="sm"
              squared
              variant="outline-primary"
              @click="toggleExpand()"
            >
              <i :class="expanded ? 'fa fa-upload' : 'fa fa-upload'"></i>
            </b-button>
          </b-col>
          <b-col cols="10">
            <div class="availtable datatable nested" style="width: 90%;">
              <b-table
                :dark="$store.state.darkMode"
                ref="grid"
                sticky-header="350px"
                striped
                hover
                small
                caption-bottom
                selectable
                select-mode="single"
                :busy="busy"
                :items="griditems"
                :fields="gridfields"
                @row-clicked="rowClicked"
              >
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner
                      variant="primary"
                      class="align-middle mr-2"
                    ></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)>
                  <i :class="options.icon" class="text-primary"></i>
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button
                      variant="link"
                      size="sm"
                      title="Actions"
                      :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')"
                    >
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover
                      container="actions-container"
                      triggers="click blur"
                      placement="leftbottom"
                      :target="'popover-target-' + row.item.id"
                    >
                      <div>
                        <b-nav vertical>
                          <b-nav-item
                            :title="action.label"
                            v-for="action in $helpers.actionsValid(
                              row.item,
                              options
                            )"
                            :key="action.key"
                            @click.stop="table_action(action.key, row)"
                          >
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i
                                  :class="action.icon"
                                  class="text-primary"
                                ></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button
                      variant="link"
                      size="sm"
                      v-for="action in $helpers.actionsValid(row.item, options)"
                      :key="action.key"
                      @click.stop="table_action(action.key, row)"
                      :title="action.label"
                    >
                      <i :class="action.icon" class="text-primary"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details="row">
                  <b-card>
                    <component
                      :is="options.component.name"
                      :search="search"
                      @discard="discard(row)"
                      @refresh="refresh()"
                    ></component>
                  </b-card>
                </template>
                <template v-slot:bottom-row>
                  <td v-for="index in 9" :key="index"></td>
                  <td class="text-danger"><strong>Total</strong></td>
                  <td class="text-right text-danger strong">
                    {{ (credit.costtotal * -1) | currency("") }}
                  </td>
                  <td class="text-right text-danger strong">
                    {{ (credit.taxes * -1) | currency("") }}
                  </td>
                  <td class="text-right text-danger strong">
                    {{ (credit.fees * -1) | currency("") }}
                  </td>
                  <td class="text-right text-danger strong">
                    {{ (credit.saletotal * -1) | currency("") }}
                  </td>
                </template>
              </b-table>
            </div>
          </b-col>
                    <b-col cols="1">
            <b-button
              size="sm"
              squared
              variant="outline-primary"
              @click="toggleExpand()"
            >
              <i :class="expanded ? 'fa fa-compress' : 'fa fa-expand'"></i>
            </b-button>
          </b-col>
        </b-row>
        <b-card-footer class="mt-2 ml-1">
          <b-row>
            <b-col class="text-left">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
                <span class="text-primary">Processing</span>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="4">
              <b-button
                squared
                size="sm"
                variant="outline-primary"
                class="mr-1"
                @click="upload"
                ><i class="fa fa-upload"></i>
                Upload
              </b-button>
              <b-button
                squared
                size="sm"
                variant="secondary"
                class="mr-1"
                @click="discard"
              >
               <i class="fa fa-chevron-left pr-1"></i>
              Back
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

export default {
  name: "ClientEmailUpload",
  data() {
    return {
      find: null,
      id: null,
      busy: false,
      filelist: [], // Store our uploaded files
      message: "",
      expanded: false,
      griditems: [],
      gridfields: [],
        credit: {
        reason: "RF",
        refund: "REFUND",
        comments: "",
        autocredit: true,
        creditbl: false,
        creditfees: false,
        creditzhold: false,
        salecode: "MU",
      },
      options: {
        title: "Edit Line Item",
        icon: "fa fa-gbp",
        debounce: 500,
        collapsedfields: [
          {
            key: "empty1",
            label: "x",
            class: "text-center w-120px",
          },
          {
            key: "empty2",
            label: "x",
            class: "text-center w-200px",
          },
          {
            key: "costtotal",
            label: "Price",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },

          {
            key: "taxes",
            label: "Taxes",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },
          {
            key: "fees",
            label: "Fees",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },
          {
            key: "saletotal",
            label: "Sale",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px w-sm-100pct",
          },
        ],
        expandedfields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-30px",
          },
          {
            key: "line",
            label: "#",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },

          {
            key: "name",
            label: "Name",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },

          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "datetravel",
            label: "Date Travel",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment(value).format("DD/MM/YYYY");
              }
              return result;
            },
          },
          {
            key: "ticketno",
            label: "Ticket#",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "passenger",
            label: "Passenger",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "blac",
            label: "BL A/C",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "qty",
            label: "Qty",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "costtotal",
            label: "Price",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },

          {
            key: "taxes",
            label: "Taxes",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },
          {
            key: "fees",
            label: "Fees",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },
          {
            key: "saletotal",
            label: "Sale",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },
        
        ],
      },
    };
  },
  methods: {
    onChange() {
      this.filelist = [...this.$refs.file.files];
    },
    remove(i) {
      this.filelist.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();

      // Add some visual fluff to show the user can drop its files
      // if (!event.currentTarget.classList.contains("bg-green-300")) {
      //   event.currentTarget.classList.remove("bg-gray-100");
      //   event.currentTarget.classList.add("bg-green-300");
      // }
      event.currentTarget.classList.add("active");
    },
    dragleave(event) {
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");

      event.currentTarget.classList.remove("active");
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
      event.currentTarget.classList.remove("active");
    },
    async upload() {
      let fileuploads = [];
      for (var j = 0; j < this.filelist.length; j++) {
        let upload = this.filelist[j];
        let data = await this.$helpers.getBase64(this.filelist[j]);
        fileuploads.push({ name: upload.name, data });
      }

      this.busy = true;
      let variables = {
        files: fileuploads,
      };
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation bspupload($files: [FileUpload_input]) {
              bspupload(files: $files)
            }
          `,
          variables,
        });
        console.log(response);

        this.message =
          "<span class='text-primary'>" + response.data.bspupload + "</span>";
      } catch (error) {
        console.log(error);
        this.message = "<span class='text-danger'>" + error + "</span>";
      }
      this.busy = false;
    },
    async rowClicked(item) {
      console.log("row clicked", item);
      this.lineitem = item;
      //   // DEFAULT COMPONENT IS THE FIRST ONE
      //   if (this.options.actions.length > 0) {
      //     if (this.options.actions[0].component) {
      //       this.options.component = this.options.actions[0].component;
      //     }
      //   }

      //   this.search.selected = item;
      //   let lo = -1;
      //   // CLOSE ALL
      //   for (var k = 0; k < this.items.length; k++) {
      //     if (this.items[k]._showDetails) {
      //       lo = k;
      //     }
      //     this.$set(this.items[k], "_showDetails", false);
      //   }
      //   item._showDetails = lo == item.ID ? false : true;
    },
    toggleExpand() {
      if (this.expanded) {
        this.gridfields = this.options.collapsedfields;
        this.griditems = [];
        this.expanded = false;
      } else {
        this.gridfields = this.options.expandedfields;
        this.griditems = this.credit.items;
        this.expanded = true;
      }
    },
    discard() {
      this.$emit("discard", null);
    },
  },
};
</script>

<style>

</style>